// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","491":"5227ff75","583":"f3be099f","614":"b6514175","995":"ee73ee9e"}[chunkId] + ".js";
};